import $http from '../../../axios';
import {MessageBox, Notification} from 'element-ui';
import axios from 'axios';
import sound from '../../../assets/sounds/sound.mp3';
import {getApiDomain} from '../../../util/domains';
import {setAcceptFinalizeDocument, setContactDefault} from './mutations';

let cancel;
const CancelToken = axios.CancelToken;

/**
 * Obtener modelos.
 */
export async function fetchModels({commit, state, dispatch}) {

    let branch_office_id = localStorage.getItem('selected_branchoffice');
    let branch_office_warehouse_id = localStorage.getItem('selected_branchoffice_warehouse');

    let params = {
        branch_office_id,
        branch_office_warehouse_id
    };

    commit('resetDocument');
    commit('resetBalancePayable');

    try {

        let response = await $http.get('/api/modelos-punto-de-venta', {params});

        commit('setAllModels', response.data.data);
        /*if (!state.all_models.length) {
            let response = await $http.get('/api/modelos-punto-de-venta', {params});

            commit('setAllModels', response.data.data);
        }*/

        let models = state.all_models.filter(m => {
            if (!!m.branchoffice_id) {
                if (m.branchoffice_id === +branch_office_id) {
                    if (!!m.branchoffice_warehouse_id) {
                        if (m.branchoffice_warehouse_id !== +branch_office_warehouse_id) {
                            return false;
                        }
                    }
                } else {
                    return false;
                }
            }

            return true;
        });

        commit('setModels', models);
        commit('setEditMode', false);
        commit('setOnlyView', false);
        commit('setToggleTable', true);

        let model = models.find(m => m.default_point_of_sale && !!m.branchoffice_id && !!m.branchoffice_warehouse_id);

        if (!model) {
            model = models.find(m => m.default_point_of_sale);
        }

        if (!model) {
            commit('setPreloader', false);

            await MessageBox.confirm('No existe el modelo por defecto de punto de venta', 'Error', {
                confirmButtonText: 'Aceptar',
                confirmButtonClass: 'btn-danger',
                showCancelButton: false,
                type: 'error',
                customClass: 'notification-error'
            });

            return;
        }

        let model_electronic_invoice = models.find(m => m.type_point_of_sale_id === 1);

        commit('setUvtControl', !!model_electronic_invoice && !!model_electronic_invoice.assign_automatic_electronic_invoice_uvt);

        const document = state.document;

        document.id = null;
        document.document_id = null;

        if (model) {
            let voucher_type = model.voucher_type;

            if (voucher_type) {
                voucher_type = await dispatch('fetchVoucherType', {
                    code: voucher_type.code_voucher_type,
                    branch_office_id
                });
            }

            if (!voucher_type) {
                commit('setPreloader', false);

                await MessageBox.confirm('El modelo no tiene tipo de comprobante', 'Error', {
                    confirmButtonText: 'Aceptar',
                    confirmButtonClass: 'btn-danger',
                    showCancelButton: false,
                    type: 'error',
                    customClass: 'notification-error'
                });

                return;
            }

            model.voucherType_id = voucher_type.id;

            model.print_template = state.print_templates.find(pt => pt.id === model.printing_format_point_of_sale_id);

            document.vouchertype_id = model.voucherType_id;
            document.model_id = model.id;
            document.contact_id = model.contact_id;
            document.operationType_id = model.operationType_id;

            if (model.contact_warehouse_point_of_sale) {
                commit('setContact', model.contact_warehouse_point_of_sale.contact);

                document.contact_id = model.contact_warehouse_point_of_sale.contact_id;

                document.warehouse_id = model.contact_warehouse_point_of_sale_id;

                if (model.contact_warehouse_point_of_sale.seller) {
                    commit('setSeller', model.contact_warehouse_point_of_sale.seller);
                    document.seller_id = model.contact_warehouse_point_of_sale.seller_id;
                } else {
                    commit('setSeller', {});
                    document.seller_id = null;
                }
            } else {
                await dispatch('fetchContactDefault');

                if (state.contact_default) {
                    commit('setContact', state.contact_default);

                    document.contact_id = state.contact_default.id;

                    const contact_warehouse = state.contact_default.warehouses[0];

                    document.warehouse_id = contact_warehouse.id;

                    if (contact_warehouse.seller) {
                        commit('setSeller', contact_warehouse.seller);
                        document.seller_id = contact_warehouse.seller_id;
                    } else {
                        commit('setSeller', {});
                        document.seller_id = null;
                    }
                }
            }

            if (model.price_list) {
                commit('setPriceListIdParams', model.price_list_id);
                commit('setPriceList', model.price_list);
            } else {
                let price_list = state.price_lists.find(pl => pl.code_parameter === '001');

                if (price_list) {
                    commit('setPriceListIdParams', price_list.id);
                    commit('setPriceList', price_list);
                }
            }

            commit('setModel', model);
            commit('setDocument', document);
        }
    } catch (e) {
        console.error(e);
    }
}

/**
 * Obtener tipo de comprobante.
 */
export async function fetchVoucherType({state, commit}, {code, branch_office_id}) {
    return new Promise(async (resolve, reject) => {
        await $http.get(`/api/tipo-comprobante/${code}/${branch_office_id}`)
            .then(response => {
                commit('setVoucherType', response.data.data);
                resolve(response.data.data);
            }).catch((error) => {
                commit('setVoucherType', null);
                reject(null);
            });
    });
}

/**
 * Obtener tercero suscriptor.
 */
export async function fetchContactSubscriber({state, commit}) {

    if (!!state.contact_subscriber) {
        return;
    }

    await $http.get('/api/tercero-suscriptor')
        .then(response => {
            commit('setContactSubscriber', response.data.data);
        }).catch(async (error) => {
            await MessageBox.confirm('El tercero suscriptor no existe', 'Error', {
                confirmButtonText: 'Aceptar',
                confirmButtonClass: 'btn-danger',
                showCancelButton: false,
                type: 'error',
                customClass: 'notification-error'
            });
        });
}

/**
 * Obtener tercero por defecto.
 */
export async function fetchContactDefault({state, commit}) {
    if (state.contact_default.id) {
        return;
    }

    await $http.get('/api/terceros/id/1')
        .then(response => {
            commit('setContactDefault', response.data.data);
        }).catch(async (error) => {
            console.error(error);
        });
}

/**
 * Obtener productos.
 */
export async function fetchProducts({commit, state, dispatch}, is_reposition_assistant = true) {

    let params = JSON.parse(JSON.stringify(state.params));

    params.filter = state.product.code.trim();

    let branch_office_id = localStorage.getItem('selected_branchoffice');
    let branch_office_warehouse_id = localStorage.getItem('selected_branchoffice_warehouse');

    params.branch_office_id = Number(branch_office_id);
    params.branch_office_warehouse_id = Number(branch_office_warehouse_id);
    params.contact_id = state.document.contact_id;
    params.contact_warehouse_id = state.document.warehouse_id;

    await $http.get('/api/buscar-productos?is_reposition_assistant=' + is_reposition_assistant, {params})
        .then(async (response) => {

            let products = response.data.data;

            let reg = new RegExp('^[0-9]*$');

            if (!!products.length && params.filter) {
                let products_filtered = products.filter(p => {
                    if (!!p.code && p.code.toLowerCase() === params.filter.toLowerCase()) {
                        return true;
                    } else if (!!p.barcode && p.barcode.toLowerCase() === params.filter.toLowerCase()) {
                        return true;
                    } else if (!!p.supplyer_code && !!p.supplyer_code.length) {
                        const supplyer_codes = p.supplyer_code.split(' ');

                        return supplyer_codes.some(sc => sc.toLowerCase().includes(params.filter.toLowerCase()));
                    }

                    return false;
                });                

                if (products_filtered.length === 1) {

                    let product = JSON.parse(JSON.stringify(products_filtered[0]));

                    commit('setProducts', products_filtered);

                    if (!params.ultra) {

                        let document_product = state.document.documents_products.find(dp => dp.product_id === product.id);

                        let quantity = null;

                        let iva_percentage = +product.percentage_sale;
                        let total_value_iva = +product.price * iva_percentage / 100;
                        let total_value_brut = +product.price;

                        product.total_value = total_value_brut + total_value_iva;

                        if (document_product) {
                            quantity = document_product.quantity;
                        }

                        product.quantity = quantity;

                        commit('setProduct', product);

                        setTimeout(() => {
                            let quantity = window.document.getElementById('quantity');

                            if (!!quantity) {
                                quantity.focus();
                                quantity.select();
                            }
                        }, 100);
                    } else {
                        let document_product = state.document.documents_products.find(dp => dp.product_id === product.id);

                        let quantity = 1;

                        commit('setProduct', product);

                        if (document_product) {

                            document_product.quantity++;
                            document_product.branchoffice_warehouse_id = state.document.branchoffice_warehouse_id;
                            document_product.original_quantity = document_product.quantity;
                            document_product.document_product_id = document_product.id;
                            document_product.model_id = state.model.id;
                            document_product.unit_value_list_before_taxes = (+document_product.unit_value_list);
                            document_product.unit_value_before_taxes = (+document_product.unit_value_list);
                            document_product.total_value_brut = (+document_product.unit_value_list) * +document_product.quantity;
                            document_product.total_value_iva = document_product.unit_value_iva * +document_product.quantity;
                            document_product.total_value = (+document_product.total_value_brut + +document_product.total_value_iva);

                            quantity = document_product.quantity;

                        } else {
                            commit('setDocumentProduct', state.product);

                            document_product = state.document_product;

                            document_product.model_id = state.model.id;

                            const document = JSON.parse(JSON.stringify(state.document));

                            document.documents_products.unshift(document_product);

                            commit('setDocument', document);
                        }

                        const audio = new Audio(sound);
                        await audio.play();

                        await dispatch('addDocumentProduct', document_product);

                        product.code = '';
                        product.quantity = quantity;

                        setTimeout(() => {

                            let code = window.document.getElementById('code');

                            if (!!code) {
                                code.focus();
                                code.select();
                            }
                        }, 100);
                    }
                } else if (products_filtered.length > 1) {
                    commit('resetProduct');
                    commit('setProducts', products_filtered);

                    const table_products = document.getElementById('table-products');

                    if (!!table_products) {
                        table_products.focus();
                    }
                } else {
                    if (!!params.filter && (params.ultra || reg.test(params.filter))) {
                        commit('resetProduct');

                        await MessageBox.confirm('El producto no existe', 'Error', {
                            confirmButtonText: 'Aceptar',
                            confirmButtonClass: 'btn-danger',
                            showCancelButton: false,
                            type: 'error',
                            customClass: 'notification-error'
                        });
                    } else {
                        commit('setProducts', products);

                        const table_products = document.getElementById('table-products');

                        if (!!table_products) {
                            table_products.focus();
                        }
                    }
                }
            } else {
                if (!!params.filter && (params.ultra || reg.test(params.filter))) {
                    commit('resetProduct');

                    await MessageBox.confirm('El producto no existe', 'Error', {
                        confirmButtonText: 'Aceptar',
                        confirmButtonClass: 'btn-danger',
                        showCancelButton: false,
                        type: 'error',
                        customClass: 'notification-error'
                    });
                } else {
                    commit('setProducts', products);

                    if (!products.length) {
                        Notification.error({
                            title: 'Error',
                            message: 'No se encontraron productos con los filtros aplicados',
                            type: 'error',
                            duration: 2000,
                            customClass: 'notification-box',
                        });
                    }
                }
            }

        })
        .catch((error) => {
            console.error(error);
        });
}

/**
 * Obtener líneas.
 */
export async function fetchLines({commit}) {

    await $http.get('/api/lineas')
        .then(response => {
            commit('setLines', response.data.data);
        }).catch((error) => {
            console.error(error);
        });
}

/**
 * Obtener marcas.
 */
export async function fetchBrands({commit}) {

    await $http.get('/api/marcas')
        .then(response => {
            commit('setBrands', response.data.data);
        }).catch((error) => {
            console.error(error);
        });
}

/**
 * Crear o actualizar documento.
 */
export async function updateOrCreateDocument({commit, state, dispatch}) {

    let copy_document = JSON.parse(JSON.stringify(state.document));

    const allowed = ['contact_id',
        'vouchertype_id',
        'warehouse_id',
        'model_id',
        'consecutive',
        'document_date',
        'document_last_state',
        'issue_date',
        'branchoffice_id',
        'branchoffice_warehouse_id',
        'operationType_id',
        'in_progress',
        'name',
        'seller_id'
    ];

    const document = Object.keys(copy_document)
        .filter(key => allowed.includes(key))
        .reduce((obj, key) => {
            obj[key] = copy_document[key];
            return obj;
        }, {});

    let branch_office_id = localStorage.getItem('selected_branchoffice');
    let branch_office_warehouse_id = localStorage.getItem('selected_branchoffice_warehouse');

    document.branchoffice_id = Number(branch_office_id);
    document.branchoffice_warehouse_id = Number(branch_office_warehouse_id);

    if (state.model.contact_warehouse_point_of_sale) {
        document.contact_id = state.model.contact_warehouse_point_of_sale.contact_id;
    } else {
        document.contact_id = state.document.contact_id;
    }

    document.model_id = state.model.id;
    document.vouchertype_id = state.model.voucherType_id;
    document.in_progress = true;

    commit('setOriginalDocumentId', null);

    await $http.post('/api/crear-o-actualizar-documento?is_point_sale=true', document)
        .then(async response => {
            commit('setFinishedDocument', false);
            commit('setAllowRollback', false);
            commit('setDocument', response.data.data);

            if (!!state.document.seller_id) {
                const seller = state.sellers.find(s => s.id === state.document.seller_id);

                if (seller) {
                    commit('setSeller', seller);
                }
            }

            if (response.data.data.contact) {
                commit('setContact', response.data.data.contact);
            }

            commit('resetProduct');

            await dispatch('fetchProducts');

        }).catch((error) => {
            commit('setFinishedDocument', false);
            commit('setAllowRollback', false);

            MessageBox.confirm(error.response.data.message, 'Error al inicializar el documento', {
                confirmButtonText: 'Aceptar',
                confirmButtonClass: 'btn-danger',
                showCancelButton: false,
                type: 'error',
                customClass: 'notification-error'
            });
        });
}

/**
 * Crear document product.
 */
export async function addDocumentProduct({commit, state, dispatch}, document_product) {

    if (state.cancel != null) {
        state.cancel();
    }

    let data = document_product;
    data.force_recalculate = !!state.edit_mode;

    await $http.post('/api/productos-documento' + '?is_point_sale=true', data, {
        cancelToken: new CancelToken(function executor(c) {
            state.cancel = c;
        })
    }).then(async response => {
        commit('setDocument', response.data.data);
    }).catch((error) => {
        console.error(error);

        commit('setDocument', error.response.data.data);

        MessageBox.confirm(error.response.data.message, 'Error', {
            confirmButtonText: 'Aceptar',
            confirmButtonClass: 'btn-danger',
            showCancelButton: false,
            type: 'error',
            customClass: 'notification-error'
        });
    });
}

/**
 * Obtener documento.
 */
export async function getDocument({commit, state, dispatch}, return_model_id = null) {

    let params = {
        model_id: state.model.id,
        force_recalculate: !!state.edit_mode
    };

    commit('setPreloader', true);

    await $http.get('/api/documento-por-id/' + state.document.id + '?is_point_sale=true', {params})
        .then(async response => {

            let document = response.data.data;

            if (return_model_id) {
                let voucher_type = await dispatch('getVoucherType', return_model_id);

                if (voucher_type) {
                    document.prefix = voucher_type.prefix;
                    document.consecutive = voucher_type.consecutive_number;
                }
            }

            if (!!document.contact) {
                document.contact.city = {};

                commit('setContact', document.contact);
            }

            if (!!document.seller && !state.seller.id) {
                commit('setSeller', document.seller);
            }

            commit('setDocument', document);
            commit('setPreloader', false);
        }).catch((error) => {
            commit('setPreloader', false);
            console.error(error);
        });

}

/**
 * Obtener documento.
 */
export async function getVoucherType({commit, state}, voucher_type_id) {

    return new Promise(async (resolve, reject) => {
        await $http.get('/api/consecutivo/' + voucher_type_id)
            .then(async response => {
                resolve(response.data);
            }).catch((error) => {
                console.error(error);
                reject(error);
            });
    });

}

/**
 * Borrar documento.
 */
export async function deleteDocument({commit, state, dispatch}) {

    commit('setPreloader', true);

    await $http.delete('/api/carrito/' + state.document.id + '?is_point_sale=true')
        .then(async response => {
            commit('setPreloader', false);
            dispatch('updateOrCreateDocument');

            Notification.success({
                title: 'Muy bien!',
                message: 'El documento se ha borrado exitosamente',
                type: 'success',
                duration: 4000,
                customClass: 'notification-box',
            });
        }).catch((error) => {
            console.error(error);
            commit('setPreloader', false);
        });
}

/**
 * Obtener documentos guardados.
 */
export async function fetchDocumentsSaved({commit, state}) {
    commit('setPreloader', true);

    let params = state.params_documents;

    params.vouchertype_id = state.document.vouchertype_id;
    params.branchoffice_id = state.document.branchoffice_id;
    params.branchoffice_warehouse_id = state.document.branchoffice_warehouse_id;

    await $http.get('/api/documentos-guardados', {params})
        .then(async response => {
            commit('setDocuments', response.data.data);
            commit('setPreloader', false);
        }).catch((error) => {
            console.error(error);
            commit('setPreloader', false);
        });
}

/**
 * Obtener documentos con solicitud de despacho.
 */
export async function fetchDocumentsWithDispatchRequest({commit}) {
    await $http.get('/api/documentos-solicitud-despacho')
        .then(async response => {
            commit('setDocumentsWithDispatchRequest', response.data.data);
        }).catch((error) => {
            console.error(error);
        });
}

/**
 * Guardar documento.
 */

export async function saveDocument({commit, state, dispatch}, keys = []) {

    let data = {};

    for (let key in state.document) {
        if (keys.includes(key)) {
            data[key] = state.document[key];
        }
    }

    data.edit_mode = state.edit_mode;

    await $http.post('/api/guardar-documento/' + state.document.id + '?is_point_sale=true', data)
        .then(async response => {
            commit('resetDocument');
            commit('setDefaultBranchOfficeAndBranchOfficeWarehouse');

            const document = state.document;

            document.vouchertype_id = state.model.voucherType_id;
            document.model_id = state.model.id;
            document.contact_id = state.model.contact_id;
            document.operationType_id = state.model.operationType_id;

            if (!!state.model.contacts && !!state.model.contacts.warehouses.length) {
                document.warehouse_id = state.model.contacts.warehouses[0].id;
            }

            commit('setDocument', document);

            await dispatch('fetchModels');
            await dispatch('updateOrCreateDocument');

            Notification.success({
                title: 'Muy bien!',
                message: 'El documento se ha guardado exitosamente',
                type: 'success',
                duration: 2000,
                customClass: 'notification-box',
            });
        }).catch((error) => {
            MessageBox.confirm(error.response.data.message, 'Error', {
                confirmButtonText: 'Aceptar',
                confirmButtonClass: 'btn-danger',
                showCancelButton: false,
                type: 'error',
                customClass: 'notification-error'
            });
        });
}

/**
 * Guardar documento.
 */
export async function saveDocumentByModelChange({commit, state, dispatch}, keys = []) {

    let data = {};
    data['documents_information'] = {};

    for (let key in state.document) {
        if (key === 'documents_information') {
            for (let key_information in state.document[key]) {
                if (keys.includes('documents_information.'+key_information)) {
                    data['documents_information'][key_information] = state.document[key][key_information];
                }
            }
        }
        if (keys.includes(key)) {
            data[key] = state.document[key];
        }
    }

    data.edit_mode = state.edit_mode;

    await $http.post('/api/guardar-documento/' + state.document.id + '?is_point_sale=true', data)
        .then(async response => {
            Notification.success({
                title: 'Muy bien!',
                message: 'El documento se ha guardado exitosamente',
                type: 'success',
                duration: 2000,
                customClass: 'notification-box',
            });

            commit('setDocument', response.data.data);
            return response;
        }).catch((error) => {
            //commit('setContact', state.document.contact);
            MessageBox.confirm(error.response.data.message, 'Error', {
                confirmButtonText: 'Aceptar',
                confirmButtonClass: 'btn-danger',
                showCancelButton: false,
                type: 'error',
                customClass: 'notification-error'
            });
            throw error;
        });
}

/**
 * Actualizar lista de precios del documento.
 */
export async function changePriceListInDocument({commit, state}, {general_discount, show_alert, from_price_list}) {

    let params = {general_discount, from_price_list};

    commit('setPreloader', true);

    await $http.post(`/api/actualizar-lista-de-precios-documento/${state.document.id}/${state.params.price_list_id}?is_point_sale=true`, params)
        .then(async response => {
            commit('setPreloader', false);
            commit('setDocument', response.data.data);

            if (show_alert) {
                if (general_discount) {
                    await MessageBox.confirm('Descuento general aplicado', 'Muy bien!', {
                        confirmButtonText: 'Aceptar',
                        confirmButtonClass: 'btn-danger',
                        showCancelButton: false,
                        type: 'success',
                        customClass: 'notification-success'
                    });
                } else {
                    await MessageBox.confirm('Se revalorizaron los productos cargados al documento con la lista de precios del Cliente', 'Muy bien!', {
                        confirmButtonText: 'Aceptar',
                        confirmButtonClass: 'btn-danger',
                        showCancelButton: false,
                        type: 'success',
                        customClass: 'notification-success'
                    });
                }
            }
        }).catch((error) => {
            commit('setPreloader', false);
            MessageBox.confirm(error.response.data.message, 'Error', {
                confirmButtonText: 'Aceptar',
                confirmButtonClass: 'btn-danger',
                showCancelButton: false,
                type: 'error',
                customClass: 'notification-error'
            });
            throw error;
        });
}

/**
 * Borrar producto del documento.
 */
export async function deleteDocumentDocumentProduct({commit, state, dispatch}, document_product_id) {

    commit('setPreloader', true);

    await $http.delete('/api/items-carrito/' + document_product_id + '?is_point_sale=true&force_recalculate=' + !!state.edit_mode)
        .then(async response => {
            commit('setPreloader', false);
            dispatch('getDocument');

            Notification.success({
                title: 'Muy bien!',
                message: 'El producto se ha borrado exitosamente',
                type: 'success',
                duration: 4000,
                customClass: 'notification-box',
            });
        }).catch((error) => {
            console.error(error);
            commit('setPreloader', false);
            MessageBox.confirm(error.response.data.message, 'Error', {
                confirmButtonText: 'Aceptar',
                confirmButtonClass: 'btn-danger',
                showCancelButton: false,
                type: 'error',
                customClass: 'notification-error'
            });
            throw error;
        });
}


/**
 * Finalizar documento
 */
export async function finalizeDocument({commit, state, dispatch}) {

    commit('setPreloader', true);

    let copy_document = JSON.parse(JSON.stringify(state.document));

    const allowed = ['contact_id',
        'vouchertype_id',
        'warehouse_id',
        'model_id',
        'document_date',
        'document_last_state',
        'issue_date',
        'operationType_id',
        'name',
        'seller_id',
        'observation'
    ];

    const document = Object.keys(copy_document)
        .filter(key => allowed.includes(key))
        .reduce((obj, key) => {
            obj[key] = copy_document[key];
            return obj;
        }, {});

    document.model_id = state.model.id;
    document.in_progress = true;
    document.document_id = state.document.id;
    document.consecutive = null;
    document.user_id_authorizes = state.params.user_id_authorizes;
    document.authorize_discount_user_id = state.params.authorize_discount_user_id;
    document.user_id_authorize_wallet_payments_methods = state.user_id_authorize_wallet_payments_methods;

    return new Promise(async (resolve, reject) => {
        if (!state.document.documents_products.some(dp => dp.quantity > 0) && state.doc_for_prods_without_avail) {
            resolve(null);
            commit('resetUserAuthentication');
        } else {
            await $http.post('/api/finalizar-documento' + '?is_point_sale=true', document)
                .then(async response => {
                    commit('setPreloader', false);

                    Notification.success({
                        title: 'Muy bien!',
                        message: 'El documento se ha finalizado exitosamente',
                        type: 'success',
                        duration: 4000,
                        customClass: 'notification-box',
                    });

                    commit('setDocument', response.data.data);

                    resolve(response.data.data);
                }).catch((error) => {
                    commit('setPreloader', false);

                    const subscriber = JSON.parse(localStorage.getItem('subscriber'));

                    const is_ventas = subscriber && subscriber.identification === '800198348';

                    if (is_ventas && !!error.response.data.data.data && error.response.data.data.type === 'stock') {
                        console.error(error.response.data.data);
                        commit('setPassInventoryValidationToDocumentsProducts', error.response.data.data.data);
                    }


                    MessageBox.confirm(error.response.data.data.message, 'Error', {
                        confirmButtonText: 'Aceptar',
                        confirmButtonClass: 'btn-danger',
                        showCancelButton: false,
                        type: 'error',
                        customClass: 'notification-error'
                    });

                    reject(error);
                }).finally(() => {
                    commit('resetUserAuthentication');
                });
        }
    });
}

/**
 * Eliminar documents products.
 */
export async function deleteDocumentsProducts({commit, state, dispatch}, documents_products_ids) {

    let params = {
        documents_products_ids
    };

    await $http.delete(`/api/eliminar-productos-documento?is_point_sale=true`, {params})
        .then(response => {
            commit('deleteItemsDocumentsProducts', documents_products_ids);
        })
        .catch(error => {
            Notification.error({
                title: '¡Error!',
                message: 'Error al eliminar el elemento.',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * Finalizar segundo documento
 */
export async function createAndFinalizeDocument({commit, state}) {
    commit('setPreloader', true);

    await $http.post('/api/crear-documento-finalizar?is_point_sale=true', state.doc_for_prods_without_avail)
        .then(async response => {
            commit('setPreloader', false);
            commit('setUrlPdf', getApiDomain() + response.data.data.invoice_link);
            commit('setShowToModalPdf', true);
        }).catch((error) => {
            console.error(error);
            commit('setPreloader', false);
        });
}

/**
 * Generar pdf
 */
export async function generatePdf({commit, state, dispatch}, id = null) {

    let document_id = state.document.id;

    if (!!id) {
        document_id = id;
    }

    commit('setPreloader', true);

    await $http.get('/api/pdf/' + document_id)
        .then(async response => {
            commit('setPreloader', false);
            commit('setUrlPdf', getApiDomain() + response.data.data.pdf);
            commit('setShowToModalPdf', true);
        }).catch((error) => {
            console.error(error);
            commit('setPreloader', false);
        });
}

/**
 * Generar pdf Ticket
 */
export async function generatePdfTicket({commit, state, dispatch}) {

    commit('setPreloader', true);

    await $http.get('/api/pdf-lite/' + state.document.id)
        .then(async response => {
            commit('setPreloader', false);
            commit('setUrlPdf', response.data.data.pdf);
            commit('setShowToModalPdf', true);
        }).catch((error) => {
            console.error(error);
            commit('setPreloader', false);
        });
}

/**
 * Validar existencia.
 */
export async function validateExistencesByDocumentId({commit, state, dispatch}) {

    commit('setPreloader', true);

    await $http.get('/api/validar-inventario-documento/' + state.document.id)
        .then(async response => {
            commit('setPreloader', false);
            commit('setPassInventoryValidationToDocumentsProducts', response.data.data);
        }).catch((error) => {
            console.error(error);
            commit('setPreloader', false);
        });
}

/**
 * Validar existencia.
 */
export async function validateExistencesByDocumentProductId({commit, state, dispatch}, document_product) {

    return new Promise(async (resolve, reject) => {

        commit('setPreloader', true);

        let params = document_product;

        await $http.get('/api/consulta-existencias', {params})
            .then(async response => {
                commit('setPreloader', false);

                resolve(response.data.data);
            }).catch((error) => {
                console.error(error);
                commit('setPreloader', false);
                reject();
            });
    });
}

/**
 * Reversar operación
 */
export async function reverseOperation({commit, state, dispatch}, document) {

    commit('setPreloader', true);
    commit('setReverseMode', true);

    await $http.post('/api/reversar-operacion/' + document.id + '?is_point_sale=true', document)
        .then(async response => {
            commit('setPreloader', false);

            if (response.data.data.code === '200') {

                Notification.success({
                    title: 'Muy bien!',
                    message: 'La operación se ha reversado exitosamente',
                    type: 'success',
                    duration: 4000,
                    customClass: 'notification-box',
                });

                commit('setPrintTemplateIdToModel', document.model.printing_format_point_of_sale_id);
                commit('setDocument', response.data.data.data);
            }

        }).catch((error) => {
            commit('setPreloader', false);

            MessageBox.confirm(error.response.data.message, 'Error', {
                confirmButtonText: 'Aceptar',
                confirmButtonClass: 'btn-danger',
                showCancelButton: false,
                type: 'error',
                customClass: 'notification-error'
            });
        });
}


/**
 * Copiar documento
 */
export async function copyDocument({commit, state, dispatch}) {

    commit('setPreloader', true);
    commit('setReverseMode', false);

    await $http.post('/api/copiar-documento/' + state.original_document_id + '?is_point_sale=true')
        .then(async response => {
            commit('setOriginalDocumentId', null);
            commit('setPreloader', false);
            commit('setDocument', response.data.data);
            commit('setContact', response.data.data.contact);
            commit('setSeller', response.data.data.seller);

            Notification.success({
                title: 'Muy bien!',
                message: 'El documento se ha creado exitosamente',
                type: 'success',
                duration: 4000,
                customClass: 'notification-box',
            });

        }).catch((error) => {
            console.error(error);
            commit('setPreloader', false);
        });
}

export async function updateDocumentValues({commit, state}) {
    let data = {
        document_id: state.document.id,
        model_id: state.model.id,
        warehouse_id: state.document.warehouse_id,
    };

    commit('setPreloader', true);

    await $http
        .post('/api/documento/actualizar-valores/', data)
        .then(response => {
            commit('setPreloader', false);
        })
        .catch(error => {
            console.error(error);
            commit('setPreloader', false);
            Notification.error({
                title: '¡Error!',
                message: 'Error al actualizar los valores del documento.',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * Obtener vendedores
 */
export async function fetchSellers({commit, state}, text = '') {
    let params = {filter: text};
    await $http.get('/api/lista-vendedores', {params})
        .then((response) => {
            commit('setSellers', response.data.data);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        });
}

/**
 * Obtiene un documento nuevo creado con base en el documento base
 */
export async function createDocumentFromBase({commit, state}, document) {
    let params = {
        document_id: document.id,
        vouchertype_id: state.model.voucherType_id,
        model_id: state.model.id,
        branchoffice_id: document.branchoffice_id,
        branchoffice_warehouse_id: document.branchoffice_warehouse_id,
        additional_documents: document.additional_documents
    };

    await $http.post('/api/documentos-inventario?is_point_sale=true', params)
        .then(response => {

            let document = response.data;

            commit('setDocument', document);

            if (document.contact) {
                document.contact.city = {};
                commit('setContact', document.contact);
            }
        })
        .catch(error => {
            Notification.error({
                title: '¡Error!',
                message: error.response.data.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * Obtener el detalle de un producto
 */
export async function getProductDetail({commit, state, rootState}, product_id) {
    let params = {
        params: {
            branchoffice_id: state.document.branchoffice_id
        }
    };

    await $http
        .get(
            '/api/calcular-precio/' + state.document.warehouse_id + '/' + product_id,
            params
        )
        .then(response => {
            commit('setProductDetail', response.data.data);
        })
        .catch(error => {
        });
}

/**
 * Obtener datos de un producto.
 */
export async function getProductsDataSheets({commit, dispatch, state}, id) {
    await $http
        .get(`/api/productos-ficha-datos/${id}`)
        .then(response => {
            commit('setDataSheets', response.data);
        })
        .catch(error => {
            Notification.error({
                title: '¡Error!',
                message: error.response.data.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * Obtener suscriptor.
 */
export async function getSubscriber({commit, dispatch, state}) {
    await $http
        .get(`/api/suscriptor`)
        .then(response => {
            commit('setSubscriber', response.data.data);
        })
        .catch(error => {
            console.error(error);
        });
}

/**
 * Obtener listas de precios
 */
export async function fetchPriceLists({commit, state}) {
    if (!state.price_lists.length) {
        await $http.get(`/api/parametros-por-codigo/LDP?sort_by=code_parameter`)
            .then((response) => {
                commit('setPriceLists', response.data.data);
            })
            .catch((error) => {
                console.error(error);
            });
    }
}

/**
 * Obtener precios
 */
export async function fetchPrices({commit, state}, product_id) {

    const params = {
        product_id,
        contact_warehouse_id: state.document.warehouse_id,
        all: 1
    };

    await $http.get(`/api/precio-producto-lista-precios`, {params})
        .then((response) => {
            commit('setPrices', response.data.data);
        })
        .catch((error) => {
            console.error(error);
        });

}

/**
 * Obtener los tipos de productos.
 */
export async function fetchTypes({commit, state}) {
    await $http
        .get('/api/parametros-por-codigo/118')
        .then(response => {
            commit('setTypes', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchDocumentsByThread({commit, state}, thread_id) {
    await $http
        .get('/api/back-order/' + thread_id)
        .then(response => {
            commit('setDocumentsByThread', response.data.data);
        })
        .catch(error => {
            console.error(error);
            Notification.error({
                title: '¡Error!',
                message: 'Error al actualizar los valores del documento.',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

// Obtener cartera del cliente
export async function getBalanceByContactId({commit, state}, contact_id = null) {

    contact_id = contact_id || state.contact.id;

    await $http
        .get(`/api/cartera/${contact_id}`)
        .then(response => {
            commit('setBalancePayable', response.data);
        })
        .catch(error => {
            console.error(error);
        });
}

/**
 * Obtener los usuarios con rol admin.
 */
export async function getUsers({commit, state}, only_admin) {
    /*if (!!state.users.length) {
        return;
    }*/

    let roles = 'superadmin;DIRECTOR CALL CENTER;GERENTE COMERCIAL';

    if (only_admin) {
        roles = 'superadmin';
    }

    await $http
        .get(`/api/usuarios-por-rol/${roles}`)
        .then(response => {
            commit('setUsers', response.data.data);
        })
        .catch(error => {
            console.error(error);
            Notification.error({
                title: '¡Error!',
                message: 'Error al obtener los usuarios.',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}


/**
 * Validar contraseña de usuario autenticador.
 */
export async function validatePassword({commit, state}, data) {
    return new Promise(async (resolve, reject) => {
        await $http
            .post('/api/validar-contrasena', data)
            .then(response => {
                resolve(true);
            })
            .catch(error => {
                reject(false);
                console.error(error);
                Notification.error({
                    title: '¡Error!',
                    message: 'Contraseña incorrecta',
                    type: 'error',
                    duration: 1500,
                    customClass: 'notification-box'
                });
            });
    });
}


/**
 * Validar orden de compra.
 */
export async function fetchValidateBuyOrder({commit, state}) {
    return new Promise(async (resolve, reject) => {

        let params = {
            id: state.document.id,
            contact_id: state.document.contact_id,
            buy_order: state.document.buy_order ? state.document.buy_order.toString() : ''
        };

        await $http
            .get('/api/validar-orden-de-compra', {params})
            .then(response => {
                resolve(response.data.data);
            })
            .catch(error => {
                console.error(error);
                Notification.error({
                    title: '¡Error!',
                    message: 'Error al validar la orden de compra',
                    type: 'error',
                    duration: 1500,
                    customClass: 'notification-box'
                });
                reject(false);
            });
    });
}

/**
 * Calcula la cartera de un tercero en base a un documento
 * @param commit
 * @param state
 * @param dispatch
 * @param return_model_id
 * @returns {Promise<void>}
 *
 * @author Oscar Sabogal
 */
export async function calculateWalletProblem({commit, state, dispatch}) {

    let params = {
        document_id: state.document.id
    };

    await $http.get('/api/calculate-wallet-problem' + '?is_point_sale=true', {params})
        .then(async response => {
            console.log(response);
        }).catch((error) => {
             MessageBox.alert(error.response.data.message, 'Error!', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: 'Aceptar',
                type: 'error',
                customClass:'notification-error'
            });
        });
}

/**
 * Validar estado factura de un documento de factura
 *
 * @param commit
 * @param state
 * @param dispatch
 * @param return_model_id
 * @returns {Promise<void>}
 *
 * @author Oscar Sabogal
 */
export async function validateStatusSalesDocument ({commit, state, dispatch}, {contact_id, warehouse_id, document_id, model_id, edit_mode}) {

    let params = {
        document_id: document_id,
        model_id: model_id,
        contact_id: contact_id,
        warehouse_id: warehouse_id,
        edit_mode: edit_mode
    };

    return await $http.get('/api/validar-estado-facturado-documento' + '?is_point_sale=true', {params})
        .then(async response => {
            return true;
        }).catch(async (error) => {
            return await MessageBox.confirm(error.response.data.data.message, 'Error', {
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                confirmButtonClass: 'btn-danger',
                showCancelButton: true,
                type: 'error',
                customClass: 'notification-error',
                dangerouslyUseHTMLString: true,
            })
                .then(() => {
                   return true;
                })
                .catch(() => {
                    return false;
                })
        });
}

export async function fetchEquivalentsProducts({commit, state}, params) {
    let branch_office_warehouse_id = localStorage.getItem('selected_branchoffice_warehouse');

    params.branch_office_warehouse_id = Number(branch_office_warehouse_id);
    await $http
        .get('/api/productos-equivalentes', {params})
        .then(response => {
            commit('setEquivalentsProducts', response.data.data);
        })
        .catch(error => {
            console.error(error);
            Notification.error({
                title: '¡Error!',
                message: 'Error al obtener los productos equivalentes.',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });

}

export async function replaceProduct({commit, state}, data) {
    state.modal_equivalent_products.loading = true;
    let dp = JSON.parse(JSON.stringify(state.modal_equivalent_products.document_product))
    let params = {
        is_point_sale               : true,
        id                          : dp.id,
        quantity                    : dp.quantity,
        document_id                 : dp.document_id,
        price_list_id               : dp.price_list_id,
        product_equivalent          : data.product_equivalent,
        branchoffice_warehouse_id   : dp.branchoffice_warehouse_id,
        general_discount            : state.document.general_discount,
    };

    await $http
        .post('/api/sustituir-producto', params)
        .then(response => {
            commit('setDocument', response.data.data);
            Notification.success({
                title: 'Muy bien!',
                message: 'El producto se ha reemplazado exitosamente',
                type: 'success',
                duration: 4000,
                customClass: 'notification-box',
            });
        })
        .catch(error => {
            Notification.error({
                title: '¡Error!',
                message: 'Error al sustituir el producto.',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
    state.modal_equivalent_products.loading = false;
    state.modal_equivalent_products.show = false;
}

export async function fetchSellersEmployeesPointOfSale({commit, state}) {
    const params = {
        paginate: false,
        is_employee: true,
        employee_category: '02'
    };

    await $http
        .get('/api/terceros-lite', { params })
        .then(response => {
            commit('setSellersEmployeesPointOfSale', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: '¡Error!',
                message: 'Error al traer los vendedores x producto.',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}


// WEBPACK FOOTER //
// ./src/point_of_sale/modules/point_of_sale/actions.js